import React from "react";
import {
    Button,
    Grid,
} from "@mui/material";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { RHFTextField, FormProvider } from "../../../common/hook-form";
import { filterBarSx, primaryBtnSx, secondaryBtnSx } from "../../../styles/patterns";


export const FilterLocation = ({ onFilter, resetFilter }) => {
    const methods = useForm({
        defaultValues: {
            name: '',
            contactNumber: ''
        }
    });
    const {
        handleSubmit,
        reset
    } = methods;

    const onSubmit = (data) => {
        onFilter(data);
    };

    return (
        <Box sx={filterBarSx}>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={3}>
                        <RHFTextField name="name" label="Name" size="small" />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <RHFTextField name="contactNumber" label="Contact No." size="small" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button type="submit" variant="contained" size="small" sx={primaryBtnSx}>Filter</Button>
                            <Button variant="outlined" size="small" sx={secondaryBtnSx} onClick={() => {
                                resetFilter()
                                reset()
                            }}>Reset</Button>
                        </Box>
                    </Grid>
                </Grid>
            </FormProvider>
        </Box>
    )
}
